import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  ClaimProductInstallationTypeModalComponent
} from '../../modals/claim-product-installation-type-modal/claim-product-installation-type-modal.component';


@Injectable()
export class ProductInstallationTypeUIService {
  constructor(
    private readonly modalGC: ModalController,
    private readonly alert: AlertController,
  ) {}

  showClaimProductInstallationTypeModal() {
    return from(
      this.modalGC.create({
        component: ClaimProductInstallationTypeModalComponent,
        cssClass: 'rounded-modal',
      }),
    ).pipe(
      switchMap(modal =>
        from(modal.present()).pipe(
          switchMap(() => modal.onDidDismiss()),
          map(({ role }) => ({ role })),
        ),
      ),
    );
  }

  confirmRemoveProductInstallationTypeClaim() {
    return from(
      this.alert.create({
        header: 'Remove Product Type',
        message: `Are you sure you want to remove this?`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'button-text-dark',
          },
          {
            text: 'Remove',
            role: 'ok',
            cssClass: 'button-text-red',
          },
        ],
      }),
    ).pipe(
      switchMap(alert =>
        from(alert.present()).pipe(
          switchMap(() => alert.onDidDismiss()),
          map(({ role }) => ({ role })),
        ),
      ),
    );
  }
}
